module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/extras/change-password/change-password.component.css
// module id = ./src/app/extras/change-password/change-password.component.css
// module chunks = main